import React, { useState, useContext } from "react";
import { Link, withRouter } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import BarChartIcon from "@material-ui/icons/BarChart";
import HomeIcon from "@material-ui/icons/Home";
import BallotIcon from "@material-ui/icons/Ballot";
import EditIcon from "@material-ui/icons/Edit";
import MailIcon from "@material-ui/icons/Mail";
import DraftsIcon from "@material-ui/icons/Drafts";
import DashboardIcon from "@material-ui/icons/Dashboard";
import SearchIcon from "@material-ui/icons/Search";
import SettingsIcon from "@material-ui/icons/Settings";
import GetAppIcon from "@material-ui/icons/GetApp";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import InfoIcon from "@material-ui/icons/Info";
import FullscreenIcon from "@material-ui/icons/Fullscreen";
import LogoutDialog from "./LogoutDialog";
import { AppContext } from "store/AppContext";
import { getIsUserAdmin } from "common/services/authService";


const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flex: 1
  },
  toolbar: theme.mixins.toolbar,
  nested: {
    paddingLeft: theme.spacing(4)
  }
}));

const DrawerContent = (props) => {
  const classes = useStyles();
  const context = useContext(AppContext);
  const cookies = new Cookies();
  const [skraningOpen, setSkraningOpen] = useState(true);
  const [tolfraediOpen, setTolfraediOpen] = useState(false);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const isKosningActive = context.activeKosning.get.id !== undefined;
  const isUserAdmin = getIsUserAdmin(context);

  const isActiveRoute = (pathname) => {
    return props.location.pathname === pathname;
  }

  const handleSkraningClick = () => {
    setSkraningOpen(!skraningOpen);
  }

  const handleTolfraediClick = () => {
    setTolfraediOpen(!tolfraediOpen);
  }

  const requestLogOut = () => {
    setLogoutDialogOpen(true);
  }

  const logout = async () => {
    //cookies.remove("accesstoken");
    const idtoken = cookies.get("id_token_hint");
    await fetch('api/auth/logout', {
      method: 'GET',
    }).then((response) => {console.log(response) }).catch((e) => {console.log("error on logout: " + e) });

    cookies.remove("jwt_token" );
    cookies.remove("id_token_hint");

    context.isLoggedIn.set(false);
    const fullLogoutUrl = `${process.env.REACT_APP_IDP_LOGOUT_URL}?post_logout_redirect_uri=${process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI}&id_token_hint=${idtoken}`;
    window.location.href = fullLogoutUrl;
  }

  return (
    <Grid
      container
      direction="column"
      alignItems="stretch"
      justify="flex-start"
      className={classes.root}
    >
      <div className={classes.toolbar} />
      <List>
        <ListItem
          button
          key="Heim"
          component={Link}
          to="/"
          selected={isActiveRoute("/")}
        >
          <ListItemIcon>
            <HomeIcon />
          </ListItemIcon>
          <ListItemText primary="Heim" />
        </ListItem>
        <ListItem button key="Skráning" onClick={handleSkraningClick}>
          <ListItemIcon>
            <BallotIcon />
          </ListItemIcon>
          <ListItemText primary="Skráning" />
          {skraningOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={skraningOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem
              button
              className={classes.nested}
              key="Atkvæði"
              component={Link}
              to="/skraning/atkvaedi"
              selected={isActiveRoute("/skraning/atkvaedi")}
              disabled={!isKosningActive}
            >
              <ListItemIcon>
                <MailIcon />
              </ListItemIcon>
              <ListItemText primary="Atkvæði" />
            </ListItem>
            {/* <ListItem
              button
              className={classes.nested}
              key="Aðsent atkvæði"
              component={Link}
              to="/skraning/adsent-atkvaedi"
              selected={isActiveRoute("/skraning/adsent-atkvaedi")}
              disabled={!isKosningActive}
            >
              <ListItemIcon>
                <DraftsIcon />
              </ListItemIcon>
              <ListItemText primary="Aðsent atkvæði" />
            </ListItem> */}
            {isUserAdmin && (
              <ListItem
                button
                className={classes.nested}
                key="fylgigognLeidrett"
                component={Link}
                to="/skraning/fylgigogn-leidrett"
                selected={isActiveRoute("/skraning/fylgigogn-leidrett")}
              >
                <ListItemIcon>
                  <EditIcon />
                </ListItemIcon>
                <ListItemText primary="Fylgigögn leiðrétt" />
              </ListItem>
            )}
          </List>
        </Collapse>
        <ListItem button key="Tölfræði" onClick={handleTolfraediClick}>
          <ListItemIcon>
            <BarChartIcon />
          </ListItemIcon>
          <ListItemText primary="Tölfræði" />
          {tolfraediOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={tolfraediOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem
              button
              className={classes.nested}
              key="Maelibord"
              component={Link}
              to="/tolfraedi/maelibord"
              selected={isActiveRoute("/tolfraedi/maelibord")}
            >
              <ListItemIcon>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText primary="Mæliborð" />
            </ListItem>
            <ListItem
              button
              className={classes.nested}
              key="Skoda"
              component={Link}
              to="/tolfraedi/skoda"
              selected={isActiveRoute("/tolfraedi/skoda")}
            >
              <ListItemIcon>
                <SearchIcon />
              </ListItemIcon>
              <ListItemText primary="Skoða nánar" />
            </ListItem>
          </List>
        </Collapse>
        <ListItem
          button
          key="Urvinnslur"
          component={Link}
          to="/urvinnslur"
          selected={isActiveRoute("/urvinnslur")}
        >
          <ListItemIcon>
            <GetAppIcon />
          </ListItemIcon>
          <ListItemText primary="Úrvinnslur" />
        </ListItem>
        <ListItem
          button
          key="Stillingar"
          component={Link}
          to="/stillingar"
          selected={isActiveRoute("/stillingar")}
        >
          <ListItemIcon>
            <SettingsIcon />
          </ListItemIcon>
          <ListItemText primary="Stillingar" />
        </ListItem>
      </List>
      <Grid container item xs></Grid>
      <Divider />
      <Grid container direction="row" justify="center" alignItems="center">
        <Tooltip title="Fylla út í skjá">
          <Button>
            <FullscreenIcon />
          </Button>
        </Tooltip>
        <Tooltip title="Upplýsingar um kerfið">
          <Button>
            <InfoIcon />
          </Button>
        </Tooltip>
        <Tooltip title="Skrá út">
          <Button onClick={requestLogOut}>
            <ExitToAppIcon />
          </Button>
        </Tooltip>
      </Grid>
      <LogoutDialog
        logoutDialogOpen={logoutDialogOpen}
        setLogoutDialogOpen={setLogoutDialogOpen}
        logout={logout}
      />
    </Grid>
  );
};

// withRouter() to get access to location prop
export default withRouter(DrawerContent);